module.exports = __webpack_public_path__ + "img/clan_clanx.13840ec.png";